import { render, staticRenderFns } from "./StoryboardCreateVersion.vue?vue&type=template&id=6788df98&lang=pug"
import script from "./StoryboardCreateVersion.vue?vue&type=script&lang=js"
export * from "./StoryboardCreateVersion.vue?vue&type=script&lang=js"
import style0 from "./StoryboardCreateVersion.vue?vue&type=style&index=0&id=6788df98&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports